import { DecorativeBgComponent } from '../../types';
import { CirclesComponent, CirclesWithStarsComponent } from './BackgroundSvgs';
import { StyledDecorativeComponent } from './DecorativeComponent.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const DecorativeComponent = ({
  decorativeBgComponent
}) => {
  const backgroundSvgs = {
    [DecorativeBgComponent.Circles]: CirclesComponent,
    [DecorativeBgComponent.CirclesWithStars]: CirclesWithStarsComponent
  };
  const BackgroundImage = backgroundSvgs[decorativeBgComponent];
  return /*#__PURE__*/_jsx(StyledDecorativeComponent, {
    children: /*#__PURE__*/_jsx("div", {
      className: decorativeBgComponent,
      children: /*#__PURE__*/_jsx("div", {
        className: `${decorativeBgComponent}__Wrapper`,
        children: /*#__PURE__*/_jsx(BackgroundImage, {})
      })
    })
  });
};